module.exports = __webpack_public_path__ + "img/9788954428170.c71c6a42.jpg";